import axios from 'axios';
const axiosApiInstance = axios.create({
    baseURL: localStorage.getItem("url"),
    headers: {
        'Content-type': 'application/json'
    }
});
axiosApiInstance.interceptors.request.use(
    function (config) {
        const authToken = localStorage.getItem('token');
        if (authToken) {
            config.headers.Authorization = `Bearer ${authToken}`;
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);
axiosApiInstance.interceptors.response.use(
    function (response) {
        return response;
       
    },
    function (error) {
        if ((error?.response?.status && error.response.status === 500) && (typeof(error?.response?.data) === 'string' && error.response.data.includes('The token is expired'))) {
            signOutLogic();
        }
        return Promise.reject(error);
    }
);

const signOutLogic = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userRole");
    localStorage.removeItem("id");
    window.location.reload();
}

export default axiosApiInstance;